import { useState } from 'react';
import { useQuery } from 'react-query';

import { StatusPageService } from '@savgroup-front-common/core/api';
import {
  getFromLocalStorage,
  setToLocalStorage,
} from '@savgroup-front-common/core/helpers';
import { AppIncident, LOCAL_STORAGE_KEYS } from '@savgroup-front-common/types';

import processIncident from '../helpers/processIncident';

const INCIDENTS_INTERVAL = 5 * 60 * 1000;

interface UseAppIncidentsArgs {
  componentName: string;
}

const useAppIncidents = ({ componentName }: UseAppIncidentsArgs) => {
  const [appIncidents, setAppIncidents] = useState<AppIncident[]>(() =>
    getFromLocalStorage({
      key: LOCAL_STORAGE_KEYS.APP_INCIDENTS,
      defaultValue: [],
    }),
  );

  useQuery(
    ['getAppIncidents'],
    async () => {
      const response = await StatusPageService.getAppIncidents();

      if (response.failure) {
        return;
      }

      setToLocalStorage({
        key: LOCAL_STORAGE_KEYS.APP_INCIDENTS,
        value: response.value,
      });

      setAppIncidents((oldIncidents) => {
        response.value.forEach((incident) => {
          processIncident(oldIncidents, incident, componentName);
        });

        return response.value;
      });
    },
    {
      staleTime: 0,
      suspense: true,
      refetchInterval: INCIDENTS_INTERVAL,
    },
  );

  return { appIncidents };
};

export default useAppIncidents;
